// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JTz+h","rowContainer":"styles_rowContainer__3B2Cc","iconWrapper":"styles_iconWrapper__Y7HNV","title":"styles_title__8u5WE","value":"styles_value__ucjzx"};